import { Component } from '@angular/core';

@Component({
  selector: 'app-ticket-report-report',
  standalone: false,
  templateUrl: './ticket-report-report.component.html',
  styleUrl: './ticket-report-report.component.scss'
})
export class TicketReportReportComponent {

}
